module.exports = __webpack_public_path__ + "static/media/cert_82.818be6c4.jpg";